import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { Modal, Button } from "@mui/material";
import { toast } from "react-toastify";
import {
  addStudent,
  get_hostel_type_from_udise,
  get_school_name_gmid,
  get_category_for_student,
  get_sub_category_for_student_by_caste,
  getAllBlocksFromDistrict,
  getVillageFromGpBlockAndDistrict,
  getGPFromDistrictAndBlock,
  newNotice,
  newGuideline,
} from "../api/Users";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../api/constant";
import { MDBTypography } from "mdb-react-ui-kit";
import adhaarImg from "../images/adhaar.png";
import { Image } from "react-bootstrap";

const AddGuideline = ({ userData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [loading, setLoading] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [guideline, setGuideline] = useState({
    heading: "",
    file: "",
    start_date: "",
    HM: false,
    WEO: false,
    DWO: false,
    DM: false,
    student: false,
    teacher: false
  });

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const handleChangeInput = (e) => {
    const { name, value, type, files, checked } = e.target;
    if (type !== "file") {
      if (type === "checkbox") {
        if (name === "all") {
          setGuideline((prevNotice) => ({
            ...prevNotice,
            HM: checked,
            WEO: checked,
            DWO: checked,
            DM: checked,
            student: checked,
            teacher: checked,
            [name]: checked,
          }));
        } else {
          setGuideline((prevNotice) => ({ ...prevNotice, [name]: checked }));
        }
      } else {
        setGuideline((prevNotice) => ({ ...prevNotice, [name]: value }));
      }
    } else {
      const file = files[0];
      setGuideline((prevNotice) => ({ ...prevNotice, [name]: file }));
    }
  };

  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();

    formData.append("guideline_text", guideline.heading);
    formData.append("file", guideline.file);
    formData.append("start_date", guideline.start_date);

    const selectedRoles = [];
    if (guideline.HM) selectedRoles.push("4");
    if (guideline.WEO) selectedRoles.push("5");
    if (guideline.DWO) selectedRoles.push("6");
    if (guideline.DM) selectedRoles.push("7");
    if (guideline.teacher) selectedRoles.push("9");
    if (guideline.student) selectedRoles.push("10");

    const rolesString = selectedRoles.join(",");
    formData.append("guideline_access_roles", rolesString);

    newGuideline(formData)
      .then((res) => {
        if (res.status === "success") {
          setIsLoading(false);
          setLoading(100);
          toast.success(t(res.message));
          navigate(`/add-guideline`);
          setGuideline({
            heading: "",
            file: "",
            start_date: "",
            HM: false,
            WEO: false,
            DWO: false,
            DM: false,
            student: false,
            teacher: false,
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          toast.error(t(res.message));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Add Guideline")}</h5>
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row col-12">
            <div
              className="row col-6 p-5"
              style={{ borderRight: "1px solid gray" }}
            >
              <div className="col-md-6">
                <label className="form-label">
                  {t("Heading")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="text"
                  name="heading"
                  value={guideline.heading}
                  className="form-control"
                  onChange={handleChangeInput}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  {t("Guideline File")}
                  <span className="text-danger"> *</span>
                </label>
                <input
                  type="file"
                  name="file"
                  className="form-control"
                  onChange={handleChangeInput}
                  accept=".pdf"
                  required
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  {t("Issue Date")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="date"
                  name="start_date"
                  value={guideline.start_date}
                  className="form-control"
                  onChange={handleChangeInput}
                  required
                  min={new Date().toISOString().split("T")[0]}
                />
              </div>
            </div>
            <div className="col-6 p-5 pt-3 row">
              <h5>{t("Select For Roles")}:</h5>
              <div className="mt-2">
                <div className="row">
                  <div className="col-md-12 d-flex">
                    <label className="form-label m-2 fw-bold">
                      {t("Select All")}:
                    </label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="all"
                      checked={guideline.all}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("Student")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="student"
                      checked={guideline.student}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("Teacher")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="teacher"
                      checked={guideline.teacher}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("HM")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="HM"
                      checked={guideline.HM}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("WEO")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="WEO"
                      checked={guideline.WEO}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DWO")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DWO"
                      checked={guideline.DWO}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DM")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DM"
                      checked={guideline.DM}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row col-12 mt-5 d-flex justify-content-end">
            <button type="submit" className="btn btn-primary me-2 col-md-2">
              {t("Save")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddGuideline;
